export function UrlPreview ({ preview }) {
  if (preview?.title && preview.description) {
    return (
      <div
        style={{
          marginTop: '15px',
          padding: '3px 3px 3px 10px',
          borderLeft: '3px solid white'
        }}
      >
        <p>
          <a
            href={preview.url}
            style={{
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            {preview.title.length > 100 ? `${preview.title.substring(0, 100)}...` : preview.title}
          </a>
        </p>
        <p
          style={{ marginTop: '5px' }}
        >
          {preview.description.length > 100 ? `${preview.description.substring(0, 100)}...` : preview.description}
        </p>
      </div>
    )
  }
  return null
}
